import styled from 'styled-components';
import type { TagFilter } from '../types';
import { isFilters } from '../types';
import { parseTag } from '../utils';
import { PopoverCard } from './popover-card';
import { StyleItem, StyleScrollbar } from './styles-base';

interface FilterMenuProps {
  tags: string[];
  filters: TagFilter[];
  onInputChange?: (value: string) => void;
}

export function FilterMenu({ tags, filters, onInputChange }: FilterMenuProps) {
  const filtersMenu = (
    <MenuList>
      {filters
        .filter((f) => {
          // 只显示 Filters 类型，过滤掉 Schemas 类型
          if (!isFilters(f)) return false;
          // 过滤掉 hidden: true 的筛选项
          if (f.hidden) return false;
          // 过滤掉已经选择的标签对应的筛选项
          const tagLabels = tags.map((tag) => parseTag(tag)?.label);
          return !tagLabels.includes(f.label);
        })
        .map((item) => (
          <MenuItem
            key={item.key}
            onClick={() => {
              // 这里 item 已经被类型守卫确保是 Filters 类型
              if (isFilters(item)) {
                onInputChange?.(item.label + ': ');
              }
            }}
          >
            {isFilters(item) ? item.label : ''}
          </MenuItem>
        ))}
    </MenuList>
  );

  if (!filters) return null;
  return <PopoverCard>{filtersMenu}</PopoverCard>;
}

/** ============================ styles ==================================== */
const MenuList = styled(StyleScrollbar)`
  overflow-y: auto;
  max-height: 300px;
  overflow-x: hidden;
  border-radius: inherit;
`;

const MenuItem = styled(StyleItem)`
  min-width: 80px;
`;
